module.exports = __webpack_public_path__ + "img/create-your-design.5cb25eda.png";